/**
 * @description 过滤旅客姓名规则
 * @param {string} str 旅客姓名
 * @param {*} rules 过滤条件
 */
export default function filterPsgName(str, rules) {
    if (rules !== 1 && rules !== 2) {
        if (rules === 5)
            str = str.replace(/( GM)$/g, '');
        if (rules === 6)
            str = str.replace(/( JC)$/g, '');
        return str;
    }
    return str.replace(/( CHD)$/g, '');
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/filterPsgName.js
// module id = null
// module chunks = 